import SliderPopover from './SliderPopover'

export default SliderPopover



// WEBPACK FOOTER //
// ./src/legacy/containers/Popovers/SliderPopover/index.js